

export const appConfig={

    headRoute:'',
    appName:'Message Moment'

}